import { render, staticRenderFns } from "./Marangu.vue?vue&type=template&id=0cabba49&scoped=true&"
import script from "./Marangu.vue?vue&type=script&lang=js&"
export * from "./Marangu.vue?vue&type=script&lang=js&"
import style0 from "./Marangu.vue?vue&type=style&index=0&id=0cabba49&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cabba49",
  null
  
)

export default component.exports